export const productDetailView = (
  babelProdotto,
  itemData,
  origin = `Product Detail page`,
  config
) => {
  if (!window.dataLayer) return;
  try {
    const { key_prod, productCode, pageLine } = babelProdotto;
    const msrpPrice = itemData?.msrpPrice?.value || null;
    const sellingPrice = itemData?.sellingPrice?.value || null;
    const omnibusValue = itemData?.omnibusPrice?.[0]?.value
      ? JSON?.parse(itemData?.omnibusPrice?.[0]?.value)?.amount
      : null;
    const omnibusPrice =
      !!omnibusValue && typeof omnibusValue === "number"
        ? omnibusValue
        : !!omnibusValue && typeof omnibusValue === "string"
        ? parseFloat(omnibusValue)
        : null;
    window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: "view_item", //per trigger in SPA
      ecommerce: {
        value: sellingPrice,
        currency: config?.currency || "EUR",
        items: [
          {
            item_name: productCode, // Name or ID is required.
            item_id: key_prod,
            price: sellingPrice,
            item_brand: "Hoover",
            item_category: pageLine?.liferayFields?.taxonomyCategoryBriefs?.[0]?.name,
            item_list_name: origin ? origin : "Other",
            item_list_id: origin ? origin.toLowerCase().replaceAll(" ", "_") : "other",
            discount:
              sellingPrice && omnibusPrice && !(omnibusPrice < sellingPrice)
                ? omnibusPrice - sellingPrice
                : sellingPrice && !omnibusPrice && msrpPrice && !(msrpPrice < sellingPrice)
                ? msrpPrice - sellingPrice
                : 0,
            index: 0,
            quantity: 1,
          },
        ],
      },
    });
  } catch (err) {
    console.error("Error in productDetailView: ", err);
  }
};

export const productImpression = (products, origin) => {
  if (!window.dataLayer) return;
  try {
    const list = products.map((item, index) => {
      const { key_prod, productCode, pageLine, priceData: itemData } = item;
      const msrpPrice = itemData?.msrpPrice?.value || null;
      const sellingPrice = itemData?.sellingPrice?.value || null;
      const omnibusValue = itemData?.omnibusPrice?.[0]?.value
        ? JSON?.parse(itemData?.omnibusPrice?.[0]?.value)?.amount
        : null;
      const omnibusPrice =
        !!omnibusValue && typeof omnibusValue === "number"
          ? omnibusValue
          : !!omnibusValue && typeof omnibusValue === "string"
          ? parseFloat(omnibusValue)
          : null;

      return {
        item_name: productCode,
        item_id: key_prod,
        item_brand: "Hoover",
        price: sellingPrice,
        item_list_name: origin ? origin : "Other",
        item_list_id: origin ? origin.toLowerCase().replaceAll(" ", "_") : "other",
        index: index,
        quantity: 1,
        item_category: pageLine?.liferayFields?.taxonomyCategoryBriefs?.[0]?.name,
        discount:
          sellingPrice && omnibusPrice && !(omnibusPrice < sellingPrice)
            ? omnibusPrice - sellingPrice
            : sellingPrice && !omnibusPrice && msrpPrice && !(msrpPrice < sellingPrice)
            ? msrpPrice - sellingPrice
            : 0,
      };
    });

    //const currency = config.currency || "EUR";

    window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: "view_item_list",
      ecommerce: {
        item_list_id: origin ? origin.toLowerCase().replaceAll(" ", "_") : "other",
        item_list_name: origin ? origin : "Other",
        items: list,
      },
    });
  } catch (err) {
    console.error("Error in productImpression: ", err);
  }
};

export const productFilters = (filterEvent) => {
  if (!window.dataLayer) {
    console.log("filterEvent", filterEvent);
    return;
  }

  try {
    window.dataLayer.push(filterEvent);
  } catch (err) {
    console.error("Error in productFilters: ", err);
  }
};

export const eventInternalLinkClick = (data) => {
  if (!window.dataLayer) return;
  try {
    window.dataLayer.push({
      event: "internal_link_click",
      data,
    });
  } catch (err) {
    console.error("Error in eventInternalLinkClick: ", err);
  }
};

export const productClick = (babelProdotto, itemData, origin = "Other", index) => {
  if (!window.dataLayer) return;
  try {
    const { key_prod, productCode, pageLine } = babelProdotto;
    const msrpPrice = itemData?.msrpPrice?.value || null;
    const sellingPrice = itemData?.sellingPrice?.value || null;
    const omnibusValue = itemData?.omnibusPrice?.[0]?.value
      ? JSON?.parse(itemData?.omnibusPrice?.[0]?.value)?.amount
      : null;
    const omnibusPrice =
      !!omnibusValue && typeof omnibusValue === "number"
        ? omnibusValue
        : !!omnibusValue && typeof omnibusValue === "string"
        ? parseFloat(omnibusValue)
        : null;

    window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: "select_item",
      ecommerce: {
        item_list_name: origin ? origin : "Other",
        item_list_id: origin ? origin.toLowerCase().replaceAll(" ", "_") : "other",
        items: [
          {
            item_name: productCode,
            item_id: key_prod,
            item_brand: "Hoover",
            price: sellingPrice,
            item_list_name: origin ? origin : "Other",
            item_list_id: origin ? origin.toLowerCase().replaceAll(" ", "_") : "other",
            index: index,
            quantity: 1,
            item_category: pageLine?.liferayFields?.taxonomyCategoryBriefs?.[0]?.name,
            discount:
              sellingPrice && omnibusPrice && !(omnibusPrice < sellingPrice)
                ? omnibusPrice - sellingPrice
                : sellingPrice && !omnibusPrice && msrpPrice && !(msrpPrice < sellingPrice)
                ? msrpPrice - sellingPrice
                : 0,
          },
        ],
      },
    });
  } catch (err) {
    console.error("Error in productClick: ", err);
  }
};

export const eventImpression = (slug, eventCategory) => {
  if (!window.dataLayer) return;
  try {
    window.dataLayer.push({
      event: eventCategory,
      slug,
    });
  } catch (err) {
    console.error("Error in eventImpression: ", err);
  }
};

export const productAddCart = (babelProdotto, priceData, position, quantity = 1) => {
  if (!window.dataLayer) return;
  try {
    const { key_prod, productCode, pageLine } = babelProdotto;
    const priceObject = priceData?.sellingPrice
      ? priceData
      : babelProdotto?.priceData
      ? babelProdotto.priceData
      : babelProdotto;
    const priceInfo = priceObject?.sellingPrice?.value
      ? priceObject.sellingPrice
      : priceObject.msrpPrice;
    const msrpPrice = priceObject?.msrpPrice?.value ? priceObject.msrpPrice.value : null;
    const sellingPrice = priceObject?.sellingPrice?.value ? priceObject.sellingPrice.value : null;
    const omnibusValue = priceObject?.omnibusPrice
      ? JSON?.parse(priceObject?.omnibusPrice?.[0]?.value)?.amount
      : null;
    const omnibusPrice =
      !!omnibusValue && typeof omnibusValue === "number"
        ? omnibusValue
        : !!omnibusValue && typeof omnibusValue === "string"
        ? parseFloat(omnibusValue)
        : null;

    window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: "addToCart",
      ecommerce: {
        currency: priceInfo?.currency || "EUR",
        value: sellingPrice,
        position: position,
        items: [
          {
            //  adding a product to a shopping cart.
            item_name: productCode,
            item_id: key_prod,
            item_brand: "Hoover",
            price: sellingPrice,
            index: 0,
            item_category: pageLine?.liferayFields?.taxonomyCategoryBriefs?.[0]?.name,
            quantity: quantity,
            discount:
              sellingPrice && omnibusPrice && !(omnibusPrice < sellingPrice)
                ? omnibusPrice - sellingPrice
                : sellingPrice && !omnibusPrice && msrpPrice && !(msrpPrice < sellingPrice)
                ? msrpPrice - sellingPrice
                : 0,
          },
        ],
      },
    });
  } catch (err) {
    console.error("Error in productAddCart: ", err);
  }
};

export const eventPdpSliderSlide = (data) => {
  if (!window.dataLayer) return;
  try {
    window.dataLayer.push({
      event: "pdp-slider-slide",
      data,
    });
  } catch (err) {
    console.error("Error in eventPdpSliderSlide: ", err);
  }
};

export const eventPdpSliderClick = (data) => {
  if (!window.dataLayer) return;
  try {
    window.dataLayer.push({
      event: "pdp-slider-click",
      data,
    });
  } catch (err) {
    console.error("Error in eventPdpSliderClick: ", err);
  }
};
